import { Component, OnInit } from '@angular/core';
import { ActivityType } from 'src/app/models/ActivityType';
import { TelementryService } from 'src/app/services/telemetry.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(
    private telementryService: TelementryService,
  ) { }

  ngOnInit(): void {
  }

  handleGtagClick(click_location: string, click_action: string): void {
    window.gTagPush(click_location, click_action)
  }

  clickFooterLink(linkName: string) {
    this.telementryService.trackSentryFeature(ActivityType.FooterLinks, {
      area: "Footer Link",
      value: linkName
    })
  }

  clickSocialLink(linkName: string) {
    this.telementryService.trackSentryFeature(ActivityType.FooterLinks, {
      area: "Social Link",
      value: linkName
    })
  }

}
